export const cilSwapVertical = ["24 24","<path d='M21.22 17.095l-3.22 3.22v-12.814h-1.5v12.868l-3.273-3.273-1.061 1.061 5.057 5.057 5.057-5.057-1.061-1.061z'></path><path d='M12.53 5.871l-5.057-5.057-5.057 5.057 1.061 1.061 3.273-3.273v12.841h1.5v-12.788l3.22 3.22 1.061-1.061z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-swap-vertical.js
// module id = null
// module chunks = 